import { useQuery } from "@tanstack/react-query";
import { getListAkunHubungkan } from "./api";

export const useGetListAkunHubungkan = ({ params, enabled }) => {
  return useQuery({
    queryKey: ["get-list-akun-hubungkan"],
    queryFn: () => getListAkunHubungkan(params),
    enabled,
  });
};
